// extracted by mini-css-extract-plugin
export default {"container":"LogicalOperator_container__mr+KX","disabled":"LogicalOperator_disabled__kfMIE"};